/**
 * Client Instance Schema Definitions
 *
 * Spec-first schema definitions for workspace-scoped client instances
 * (client_instance_id → remote server host/port).
 */

import { z } from "zod";
import {
  UuidField,
  TimestampField,
  MetadataField,
  ErrorResponse,
} from "./common";

const Host = z.string().min(1);
const Port = z.int().min(1).max(65535);

// Core ClientInstance entity
const ClientInstance = z.object({
  id: UuidField,
  workspaceId: UuidField,
  host: Host,
  port: Port,
  metadata: MetadataField,
  createdAt: TimestampField,
  updatedAt: TimestampField,
});

// Request schemas
const PutClientInstanceRequest = z.object({
  host: Host,
  port: Port,
  metadata: MetadataField,
});

// Export all schemas
export const schemas = {
  ClientInstance,
  PutClientInstanceRequest,
  ErrorResponse,
};

// oRPC Type Inference Support
export type SchemaTypes = {
  [K in keyof typeof schemas]: z.infer<(typeof schemas)[K]>;
};

export type { SchemaTypes as ClientInstanceSchemaTypes };
export { schemas as clientInstanceSchemas };
